import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

export const SiteTypeInput = ({ onChange, defaultValues }) => {
    const allowed = new Set([
        'city agency',
        'private developer',
        'community garden',
        'school garden'
    ]);
    let o = false,
        dov = '';
    if (defaultValues)
        new Set(defaultValues).forEach((v) => {
            if (!allowed.has(v)) {
                o = true;
                dov = v;
            }
        });
    const [state, setState] = useState(defaultValues || new Set());
    const [other, setOther] = useState(o);
    const [otherVal, setOtherVal] = useState(dov);
    const handleCheck = (val) => {
        const checked = new Set(state);
        const v = val.toLowerCase();
        if (checked.has(v)) {
            checked.delete(v);
        } else {
            checked.add(v);
        }
        setState(checked);
    };

    const handleOther = (val) => {
        const checked = new Set(state);

        checked.delete(otherVal);
        if (!val || val == '') {
            setOtherVal('');
        } else {
            setOtherVal(val);
            checked.add(val);
        }
        setState(checked);
    };

    useEffect(() => {
        onChange(state);
    }, [state]);

    useEffect(() => {
        if (!other) handleOther('');
    }, [other]);

    return (
        <>
            <Form.Label htmlFor={`site_type`}>Site Type</Form.Label>
            <Form.Group>
                <Form.Check
                    onChange={(e) => {
                        handleCheck(e.target.value);
                    }}
                    type='checkbox'
                    id='city_agency'
                    label='City Agency'
                    value='City Agency'
                    checked={state.has('city agency')}
                />
                <Form.Check
                    onChange={(e) => {
                        handleCheck(e.target.value);
                        return e.target.value;
                    }}
                    type='checkbox'
                    id='private_developer'
                    label='Private Developer'
                    value='Private Developer'
                    checked={state.has('private developer')}
                />
                <Form.Check
                    onChange={(e) => {
                        handleCheck(e.target.value);
                    }}
                    type='checkbox'
                    id='community_garden'
                    label='Community Garden'
                    value='Community Garden'
                    checked={state.has('community garden')}
                />
                <Form.Check
                    onChange={(e) => {
                        handleCheck(e.target.value);
                    }}
                    type='checkbox'
                    id='school_garden'
                    label='School Garden'
                    value='School Garden'
                    checked={state.has('school garden')}
                />
                <div className='d-flex'>
                    <Form.Check
                        onChange={(e) => {
                            setOther((currOther) => !currOther);
                        }}
                        type='checkbox'
                        id='other_site_type'
                        label='Other'
                        value='Other'
                        checked={other}
                    />
                    <Form.Control
                        type='text'
                        className='ml-2'
                        style={{ width: '20%', height: '100%', padding: 0 }}
                        onChange={(e) => handleOther(e.target.value)}
                        value={otherVal}
                        disabled={!other}
                    ></Form.Control>
                </div>
            </Form.Group>
        </>
    );
};

SiteTypeInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    defaultValues: PropTypes.instanceOf(Set),
};
